import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=27162d6e&scoped=true&"
import script from "./SystemConfig.vue?vue&type=script&lang=js&"
export * from "./SystemConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27162d6e",
  null
  
)

export default component.exports